import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/v0831_home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/aed',
      name: 'aed',
      component: () => import('@/components/v0402_home.vue'),
      meta: { title: 'AED' }
    },
    {
      path: '/guide',
      name: 'guide',
      component: () => import('@/components/v0831_guide.vue'),
      meta: { title: '操作指南' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js